import { render, staticRenderFns } from "./ProductSearchModal.vue?vue&type=template&id=5e2730ba&scoped=true&"
import script from "./ProductSearchModal.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchModal.vue?vue&type=style&index=0&id=5e2730ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2730ba",
  null
  
)

export default component.exports